'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * 变量模块
 */
exports.default = {
    // 埋点发送之前执行的钩子函数
    send: function send() {},

    // 用户传递的app模块
    setApp: function setApp(app) {
        var _this = this;

        var flag = false;
        if (app) {
            if (typeof app.load === 'function' && app.load()) {
                var load = app.load();
                if (load.then) {
                    // 如果load是Promise
                    return load.then(function (res) {
                        _this.setBury(res, app);
                    }).catch(function (e) {
                        _this.setBury(e, app);
                    });
                } else {
                    flag = !!load;
                }
            }
            if (typeof app.load !== 'function' && app.load !== false) {
                flag = true;
            }
            this.setBury(flag, app);
        }
    },
    setBury: function setBury(flag, app) {
        if (flag && app.Tower && app.Tower.app && app.Tower.bury) {
            this.bury = app.Tower.bury;
        }
    },

    bury: null
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-vue/vue-burying/dist/variable.js
// module id = O1uz
// module chunks = 11